<div class="holder">
  <button (click)="addCar()" [style.margin-bottom.px]="25" matButton="outlined">
    Lägg till bil
  </button>
  @for (car of carsControls.controls; let i = $index; track i) {
    <div class="cars">
      <mat-form-field>
        <mat-label>Typ av bilägande</mat-label>
        <mat-select [formControl]="car">
          @for (ct of carTypeMap | keyvalue; track ct.key) {
            <mat-option [value]="ct.key">{{ ct.value }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button (click)="removeCar(i)" class="form-margin"
              mat-icon-button>
        <mat-icon class="negative">delete</mat-icon>
      </button>
    </div>
  }
</div>